module.exports = __webpack_public_path__ + "static/media/brush_7.d8b900b2.png";